// @ts-strict-ignore
import React from 'react'
import { useFilePreview } from './provider'
import { PlaceholderView, StyledImage, PDFIcon } from './styles'
import { ImageFile, SupportedFile } from './types'
import { Pressable } from 'react-native'
import { Images } from 'APP/Themes'
import { LoadingIndicator } from 'APP/Components/AppointmentBooking/common/loadingIndicator'

export const ImagePreview: React.FC<{ file: ImageFile }> = ({ file }) => {
  const { aspectRatio = 1 } = useFilePreview()
  return (
    <StyledImage
      source={file?.uri ? { uri: file.uri } : undefined}
      aspectRatio={aspectRatio}
      accessibilityRole="image"
      testID="IMAGE_PREVIEW"
      alt={file?.alt}
    />
  )
}

export const PDFPreview = () => {
  const { aspectRatio = 1 } = useFilePreview()

  return (
    <PlaceholderView aspectRatio={aspectRatio} testID="PDF_PREVIEW">
      <PDFIcon source={Images.pdfIcon} />
    </PlaceholderView>
  )
}

const PreviewRenderer = () => {
  const { file, renderPreview, isLoading, aspectRatio = 1 } = useFilePreview()

  if (isLoading) {
    return (
      <PlaceholderView aspectRatio={aspectRatio} testID="PLACE_HOLDER">
        <LoadingIndicator />
      </PlaceholderView>
    )
  }

  if (renderPreview && file) {
    return <>{renderPreview(file)}</>
  }

  switch (file?.type) {
    case 'image':
      return <ImagePreview file={file} />
    case 'pdf':
      return <PDFPreview />
    default:
      return null
  }
}

const ClickableWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { file, onClick } = useFilePreview()

  if (!onClick) return <>{children}</>

  return (
    <Pressable
      onPress={() => onClick(file as SupportedFile)}
      accessibilityRole="button"
      accessibilityLabel={`Preview ${file?.name}`}
      testID="PREVIEW_BUTTON"
    >
      {children}
    </Pressable>
  )
}

export const PreviewContent = () => (
  <ClickableWrapper>
    <PreviewRenderer />
  </ClickableWrapper>
)
